export const SMALL_DESKTOP_DEVICE_SIZE = '1120PX';
export const MOBILE_DEVICE_MEDIA_QUERY = '@media (max-width: 768px)';
export const TABLET_DEVICE_MEDIA_QUERY = '@media (max-width: 1024px)';
export const SMALL_DESKTOP_DEVICE_MEDIA_QUERY = `@media only screen and (max-width:${SMALL_DESKTOP_DEVICE_SIZE})`;
export const DRAWER_WIDTH = 240;
